// extracted by mini-css-extract-plugin
module.exports = {"container":"_5kbZD6e5c3Tyoz20YADhS"};